import React from 'react';
import { styled } from '@compiled/react';
import FlagFilledIcon from '@atlaskit/icon/core/flag-filled';
import FlagFilledIconOld from '@atlaskit/icon/glyph/flag-filled';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type Props = {
	isFlagged: boolean;
	shouldRenderInlineAddFlag: boolean;
};
export const Flag = ({ shouldRenderInlineAddFlag, isFlagged }: Props) => {
	const inlineFlag = shouldRenderInlineAddFlag ? <FlagPlaceHolder /> : null;
	const flagIcon = (
		<FlagFilledIcon
			label="Flagged icon"
			color={token('color.icon.danger', colors.R300)}
			LEGACY_fallbackIcon={FlagFilledIconOld}
			LEGACY_size="small"
			LEGACY_primaryColor={token('color.icon.danger', colors.R300)}
		/>
	);
	return <FlagContainer>{isFlagged ? flagIcon : inlineFlag}</FlagContainer>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlagContainer = styled.div({
	position: 'relative',
	zIndex: 1 /* surface the element above the interaction layer so tooltips can be triggered */,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlagPlaceHolder = styled.div({
	width: '16px',
	height: '24px',
});
